var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tree-item" }, [
    _c("div", { staticClass: "tree-item-content" }, [
      _vm.item.children && _vm.item.children.length
        ? _c(
            "span",
            {
              staticClass: "toggle",
              on: {
                click: function ($event) {
                  _vm.isExpanded = !_vm.isExpanded
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.isExpanded ? "−" : "+") + " ")]
          )
        : _c("span", { staticClass: "toggle-spacer" }),
      _c("label", { staticClass: "tree-label" }, [
        _c("input", {
          ref: "checkbox",
          attrs: { type: "checkbox" },
          domProps: { checked: _vm.selected.includes(_vm.item.id) },
          on: {
            change: function ($event) {
              return _vm.$emit("toggle", _vm.item.id)
            },
          },
        }),
        _c("span", [_vm._v(_vm._s(_vm.item.name))]),
      ]),
    ]),
    _vm.isExpanded && _vm.item.children
      ? _c(
          "div",
          { staticClass: "tree-children" },
          _vm._l(_vm.item.children, function (child) {
            return _c("tree-item", {
              key: child.id,
              attrs: { item: child, selected: _vm.selected },
              on: {
                toggle: function ($event) {
                  return _vm.$emit("toggle", $event)
                },
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }